import React from "react";

const LanguageSwitcher = ({ lang, setLang }) => {
  return (
    <div
      className="flex items-center gap-1 p-1 bg-black/60 backdrop-blur-md rounded-full border border-white/10 font-mono-display text-[11px] uppercase tracking-[0.2em]"
      data-testid="lang-switcher"
    >
      <button
        type="button"
        data-testid="lang-ru-btn"
        onClick={() => setLang("ru")}
        className={`px-3 py-1.5 rounded-full transition-colors ${
          lang === "ru"
            ? "bg-[#FF1493] text-black font-bold"
            : "text-zinc-400 hover:text-white"
        }`}
      >
        RU
      </button>
      <button
        type="button"
        data-testid="lang-en-btn"
        onClick={() => setLang("en")}
        className={`px-3 py-1.5 rounded-full transition-colors ${
          lang === "en"
            ? "bg-[#FF1493] text-black font-bold"
            : "text-zinc-400 hover:text-white"
        }`}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
